import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    pageLayout: {
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing(2),
        flex: 1,
        minHeight: 0,
    },
    mainContent: {
        flex: "4 1 0",
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
    },
    dropzoneContainer: {
        paddingBottom: theme.spacing(4),
        margin: "0 auto",
        marginTop: theme.spacing(2),
        display: "block",
    },
    uploadContainer: {
        width: "100%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: theme.spacing(5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        "& .MuiInputBase-root.Mui-disabled": {
            color: theme.palette.emteria.text.primary,
            borderColor: theme.palette.emteria.text.primary,
        },
    },
    contentBox: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
    },
    uploadTooltipContainer: {
        width: "100%",
    },
}));
